const ossApi = '/ossApi'
let hostname = window.location.hostname
const encryptionJS = require('../../assets/js/encryption');
// 社工
let areaCode = '11'
let tenantCode = ''
let title = ''
let imageUrl = ''
let username = ''
let password = ''
let serviceUrl = ''  //履职服务平台
let systemType = ''

if (hostname === 'hqq.xxszx.gov.cn' || hostname === 'www.hqq.xxszx.gov.cn') {
  areaCode = '410702'
  tenantCode = '410702000000000001'
  title = '红旗区'
  imageUrl = ossApi + '/zx410702'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('LcCUgE61LHzl5+2xtxPnvQ==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'wbq.xxszx.gov.cn' || hostname === 'www.wbq.xxszx.gov.cn') {
  areaCode = '410703'
  tenantCode = '410703000000000001'
  title = '卫滨区'
  imageUrl = ossApi + '/zx410703'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('t2V44ZbQGT6wbM/aYJKhcg==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'fqq.xxszx.gov.cn' || hostname === 'www.fqq.xxszx.gov.cn') {
  areaCode = '410704'
  tenantCode = '410704000000000001'
  title = '凤泉区'
  imageUrl = ossApi + '/zx410704'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('GmOKSDSobbOwxJkeMypPrQ==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'myq.xxszx.gov.cn' || hostname === 'www.myq.xxszx.gov.cn') {
  areaCode = '410711'
  tenantCode = '410711000000000001'
  title = '牧野区'
  imageUrl = ossApi + '/zx410711'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('QZQ+d1n/Gk8kFMGFgUMcfA==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'xxx.xxszx.gov.cn' || hostname === 'www.xxx.xxszx.gov.cn') {
  areaCode = '410721'
  tenantCode = '410721000000000001'
  title = '新乡县'
  imageUrl = ossApi + '/zx410721'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('QrIxrRirxKIGQ8eGXDv9QQ==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'hjx.xxszx.gov.cn' || hostname === 'www.hjx.xxszx.gov.cn') {
  areaCode = '410724'
  tenantCode = '410724000000000001'
  title = '获嘉县'
  imageUrl = ossApi + '/zx410724'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('U8aaGw/zxQiqw1KZ0gODpw==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'yyx.xxszx.gov.cn' || hostname === 'www.yyx.xxszx.gov.cn') {
  areaCode = '410725'
  tenantCode = '410725000000000001'
  title = '原阳县'
  imageUrl = ossApi + '/zx410725'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('9UeLtESF3rY/dRSdGGttrg==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'yjx.xxszx.gov.cn' || hostname === 'www.yjx.xxszx.gov.cn') {
  areaCode = '410726'
  tenantCode = '410726000000000001'
  title = '延津县'
  imageUrl = ossApi + '/zx410726'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('X0wsncw4Nalc7pS+5KGROQ==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'fqx.xxszx.gov.cn' || hostname === 'www.fqx.xxszx.gov.cn') {
  areaCode = '410727'
  tenantCode = '410727000000000001'
  title = '封丘县'
  imageUrl = ossApi + '/zx410727'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('O1XwruzGzP10ld0AzWwJJw==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'whs.xxszx.gov.cn' || hostname === 'www.whs.xxszx.gov.cn') {
  areaCode = '410781'
  tenantCode = '410781000000000001'
  title = '卫辉市'
  imageUrl = ossApi + '/zx410781'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('tFhti01yynCqF9SIByxwhA==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}
if (hostname === 'hxs.xxszx.gov.cn' || hostname === 'www.hxs.xxszx.gov.cn') {
  areaCode = '410782'
  tenantCode = '410782000000000001'
  title = '辉县市'
  imageUrl = ossApi + '/zx410782'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('HUakC0opWzIsjpLD8Wq7Rw==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
}

switch (process.env.NODE_ENV) {
  case 'development': // 开发环境
    areaCode = '410782'
    tenantCode = '410782000000000001'
    title = '辉县市'
    imageUrl = ossApi + '/zx410782'
    serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
    systemType = 'cppcc'
    username = encryptionJS.aesDecrypt('HUakC0opWzIsjpLD8Wq7Rw==')
    password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
    break
  default:
    break
}
export default {
  ossApi,
  tenantCode,
  title,
  imageUrl,
  username,
  password,
  areaCode,
  serviceUrl,
  systemType
}
